import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import axios from '../../utils/axiosConfig';

const FormEditarCheckList = ({ allData, handleCloseModalEditarCheckList, handleSaveChanges }) => {
    const [formData, setFormData] = useState({
        nombreConductor: '',
        placa: '',
        observaciones: '',
    });

    // Estado para controlar el "loading" del botón
    const [loading, setLoading] = useState(false);

    // Maneja los cambios en los inputs, usando el atributo "name" para identificar el campo
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value.toUpperCase(), // Convierte el valor a mayúsculas
        }));
        // console.log(`Cambio en ${name}: ${value.toUpperCase()}`);
    };

    // Función para manejar el clic en "Guardar"
    const handleGuardar = async () => {
        setLoading(true);
        // console.log("Guardando datos: ", formData);
        const newData = {
            contrato: allData[0].Fk_ContractID,
            conductor: formData.nombreConductor,
            placa: formData.placa,
            observaciones: formData.observaciones,
        }
        try {

            const res = await axios.post(
                `${process.env.REACT_APP_SERVER}/operaciones/updatechecklist`, JSON.stringify(newData),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                }
            );

            if (res.data.success) {
                // console.log("Datos guardados correctamente:", res.data);
                handleCloseModalEditarCheckList(); // Cierra el modal después de guardar
                handleSaveChanges(); // Llama a la función para guardar los cambios
            } else {
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo actualizar el checklist.',
                    icon: 'error',
                    showConfirmButton: true,
                });
            }

        } catch (error) {
            console.error("Error al guardar:", error);
            Swal.fire({
                title: 'Error',
                text: `Ocurrió un error al guardar los datos : ${error.message}`,
                icon: 'error',
                showConfirmButton: true,
            });
        } finally {
            setLoading(false);
        }
    };

    // Inicializa el formulario con la información recibida por props (allData)
    useEffect(() => {
        // console.log("Props de FormEditarCheckList:", allData);
        if (allData && allData.length > 0) {
            setFormData({
                nombreConductor: allData[0].nombre_conductor1.toUpperCase() || '',
                placa: allData[0].placa1.toUpperCase() || '',
                observaciones: '',
            });
        }
    }, [allData]);

    return (
        <form>
            {/* Campo Nombre Conductor */}
            <div style={{ marginBottom: '16px' }}>
                <label htmlFor="nombreConductor" style={{ display: 'block', marginBottom: '8px' }}>
                    Nombre Conductor:
                </label>
                <input
                    type="text"
                    id="nombreConductor"
                    name="nombreConductor"
                    value={formData.nombreConductor}
                    onChange={handleChange}
                    style={{
                        width: '96%',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                    }}
                />
            </div>
            {/* Campo Placa */}
            <div style={{ marginBottom: '16px' }}>
                <label htmlFor="placa" style={{ display: 'block', marginBottom: '8px' }}>
                    Placa:
                </label>
                <input
                    type="text"
                    id="placa"
                    name="placa"
                    value={formData.placa}
                    onChange={handleChange}
                    maxLength={7}
                    style={{
                        width: '96%',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        transform: 'uppercase',
                    }}
                />
            </div>
            {/* Campo Observaciones */}
            <div style={{ marginBottom: '16px' }}>
                <label htmlFor="observaciones" style={{ display: 'block', marginBottom: '8px' }}>
                    Observaciones:
                </label>
                <input
                    type="text"
                    id="observaciones"
                    name="observaciones"
                    value={formData.observaciones}
                    onChange={handleChange}
                    style={{
                        width: '96%',
                        padding: '8px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                    }}
                />
            </div>
            {/* Botón Guardar */}
            <div style={{ textAlign: 'center', marginTop: '16px' }}>
                <button
                    type="button"
                    onClick={handleGuardar}
                    disabled={loading}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: loading ? '#ccc' : '#006699',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        fontSize: '16px',
                    }}
                >
                    {loading ? (
                        <>
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                                style={{ marginRight: '8px' }}
                            ></span>
                            Guardando...
                        </>
                    ) : (
                        "Guardar"
                    )}
                </button>
            </div>
        </form>
    );
};

export default FormEditarCheckList;
